import { css } from '@emotion/react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { defineMessage, useIntl } from 'react-intl';
import { ChatDialogEventReason } from 'sdk';

import { useSDK } from '../../../../app';
import { styled } from '../../../../styled';
import type { Theme } from '../../../../theme/interface/detailed';
import { useSanitize } from '../../../../utils/useSanitize';

const FINISHED_BY_OPERATOR = defineMessage({
	id: 'chat.dialogResolvedByOperator',
	defaultMessage: 'Оператор завершил диалог',
});
const styles = css`
	& > div,
	& > div {
		text-align: center;
	}
`;

const Component = observer(({ className }: { className: string; finisher?: ChatDialogEventReason }): ReactElement => {
	const rootStore = useSDK();
	const resolveHtml = useSanitize(rootStore.welcomeDataStore.data?.showcase.resolveText || '');
	const intl = useIntl();
	return (
		<div className={className}>
			<div>{intl.formatMessage(FINISHED_BY_OPERATOR)}</div>
			{resolveHtml && <div dangerouslySetInnerHTML={resolveHtml} />}
		</div>
	);
});

export const DialogResolvedMessage = styled(Component)(
	({ theme }: { theme: Theme }) => theme.chat.systemMessages.systemMessage,
	styles
);
